import { render, staticRenderFns } from "./BPagination.vue?vue&type=template&id=0b534566&"
import script from "./BPagination.vue?vue&type=script&lang=js&"
export * from "./BPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports